"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAutoRoutingAllMetricsList = exports.retryList = exports.fetchLogoutFEList = exports.unAssignFE = exports.unAssignedFE = exports.availableFEsData = exports.availableFEsList = exports.staticClientsList = exports.onDemandReject = exports.pickUpStaticList = exports.onDemandPickupList = exports.totalPickUpList = exports.fetchTotalFEList = exports.fetchTotalActiveClientsList = exports.autoRoutingDashboard = void 0;
var api_service_1 = require("../../../api/api_service");
var autoRoutingDashboard = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.AUTO_ROUTING_COUNTS,
            domain: process.env.APPROVAL_BASEURL,
            payLoad: payload,
        })
            .then(function (res) {
            if (res.data.statusCode === 200) {
                console.log(res, 'response');
                return resolve(res.data);
            }
            var erroMessage = res.data
                ? res.data.message
                : 'Unable to process your request.';
            throw new Error(erroMessage);
        })
            .catch(function (e) {
            return reject(e.message);
        });
    });
};
exports.autoRoutingDashboard = autoRoutingDashboard;
var fetchTotalActiveClientsList = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.TOTAL_ACTIVE_CLIENTS_LIST,
            domain: process.env.APPROVAL_BASEURL,
            payLoad: payload,
        })
            .then(function (res) {
            if (res.data.statusCode === 200) {
                return resolve(res.data.data);
            }
            throw new Error(res.data.message);
        })
            .catch(function (e) {
            return reject(e);
        });
    });
};
exports.fetchTotalActiveClientsList = fetchTotalActiveClientsList;
var fetchTotalFEList = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.TOTAL_FE,
            domain: process.env.APPROVAL_BASEURL,
            payLoad: payload,
        })
            .then(function (res) {
            if (res.data.statusCode === 200) {
                return resolve(res.data.data);
            }
            throw new Error(res.data.message);
        })
            .catch(function (e) {
            return reject(e);
        });
    });
};
exports.fetchTotalFEList = fetchTotalFEList;
var totalPickUpList = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.TOTAL_PICKUPS,
            domain: process.env.APPROVAL_BASEURL,
            payLoad: payload,
        })
            .then(function (res) {
            if (res.data.statusCode === 200) {
                return resolve(res.data.data);
            }
            throw new Error(res.data.message);
        })
            .catch(function (e) {
            return reject(e.message);
        });
    });
};
exports.totalPickUpList = totalPickUpList;
var onDemandPickupList = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.ONDEMAND_PICKUPS,
            domain: process.env.APPROVAL_BASEURL,
            payLoad: payload,
        })
            .then(function (res) {
            if (res.data.statusCode === 200) {
                return resolve(res.data.data);
            }
            throw new Error(res.data.message);
        })
            .catch(function (e) {
            return reject(e.message);
        });
    });
};
exports.onDemandPickupList = onDemandPickupList;
var pickUpStaticList = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.PICKUP_STATIC_LIST,
            domain: process.env.APPROVAL_BASEURL,
            payLoad: payload,
        })
            .then(function (res) {
            if (res.data.statusCode === 200) {
                return resolve(res.data.data);
            }
            throw new Error(res.data.message);
        })
            .catch(function (e) {
            return reject(e.message);
        });
    });
};
exports.pickUpStaticList = pickUpStaticList;
var onDemandReject = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.ONDEMAND_REJECT,
            domain: process.env.APPROVAL_BASEURL,
            payLoad: payload,
        })
            .then(function (res) {
            if (res.data.statusCode === 200) {
                return resolve(res.data.statusCode);
            }
            throw new Error(res.data.message);
        })
            .catch(function (e) {
            return reject(e.message);
        });
    });
};
exports.onDemandReject = onDemandReject;
var staticClientsList = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.STATIC_CLIENTS_LIST,
            domain: process.env.APPROVAL_BASEURL,
            payLoad: payload,
        })
            .then(function (res) {
            if (res.data.statusCode === 200) {
                return resolve(res.data.data);
            }
            throw new Error(res.data.message);
        })
            .catch(function (e) {
            return reject(e.message);
        });
    });
};
exports.staticClientsList = staticClientsList;
var availableFEsList = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .get({
            endPoint: api_service_1.api_service.api_urls.AVAILABLE_FES,
            domain: process.env.VENDOR_BASE_URL,
            payLoad: payload,
        })
            .then(function (response) {
            if (response.status === 200) {
                return resolve(response.data.data);
            }
            throw new Error(response.message);
        })
            .catch(function (err) {
            return reject(err);
        });
    });
};
exports.availableFEsList = availableFEsList;
var availableFEsData = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .get({
            endPoint: "".concat(api_service_1.api_service.api_urls.AVAILABLE_FES, "?").concat(payload),
            domain: process.env.VENDOR_BASE_URL
        })
            .then(function (response) {
            if (response.status === 200) {
                return resolve(response.data.data);
            }
            throw new Error(response.message);
        })
            .catch(function (err) {
            return reject(err);
        });
    });
};
exports.availableFEsData = availableFEsData;
var unAssignedFE = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.UN_ASSIGNED_VISITS,
            domain: process.env.VENDOR_BASE_URL,
            payLoad: payload,
        })
            .then(function (res) {
            if (res.data.statusCode === 200) {
                return resolve(res.data.message);
            }
            throw new Error(res.data.message);
        })
            .catch(function (e) {
            return reject(e.message);
        });
    });
};
exports.unAssignedFE = unAssignedFE;
var unAssignFE = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.UN_ASSIGNED_VISITS,
            domain: process.env.VENDOR_BASE_URL,
            payLoad: payload,
        })
            .then(function (res) {
            if (res.data.statusCode === 200) {
                return resolve(res.data);
            }
            resolve(res.message);
        })
            .catch(function (e) {
            return reject(e.message);
        });
    });
};
exports.unAssignFE = unAssignFE;
var fetchLogoutFEList = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.LOGOUT_FE_LIST,
            domain: process.env.APPROVAL_BASEURL,
            payLoad: payload,
        })
            .then(function (res) {
            if (res.data.statusCode === 200) {
                return resolve(res.data.data);
            }
            throw new Error(res.data.message);
        })
            .catch(function (e) {
            return reject(e);
        });
    });
};
exports.fetchLogoutFEList = fetchLogoutFEList;
var retryList = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.RETRY_PROCESSING,
            domain: process.env.VENDOR_BASE_URL,
            payLoad: payload,
        })
            .then(function (res) {
            resolve(res.data);
        })
            .catch(function (e) {
            return reject(e.message);
        });
    });
};
exports.retryList = retryList;
var getAutoRoutingAllMetricsList = function (endPoint, payLoad, domain) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2, new Promise(function (resolve, reject) {
                api_service_1.api_service
                    .post({
                    endPoint: endPoint,
                    domain: domain,
                    payLoad: payLoad,
                })
                    .then(function (response) {
                    if (response.status === 200) {
                        return resolve(response.data.data);
                    }
                    var erroMessage = response.data
                        ? response.data.message
                        : 'Unable to process your request.';
                    throw new Error(erroMessage);
                })
                    .catch(function (e) {
                    return reject(e.message);
                });
            })];
    });
}); };
exports.getAutoRoutingAllMetricsList = getAutoRoutingAllMetricsList;
